import React, {useState, useRef} from "react";
import * as XLSX from 'xlsx';
import {CircularProgress} from "@mui/material";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
  getFirestore,
} from "firebase/firestore";
import {useUser} from "../UserContext.js";
import {useSnackbar} from "notistack";
import {Button} from "@mui/material";
import "./../Styles.css";

function AdminAddUser() {
  const {appUser} = useUser();
  const {enqueueSnackbar} = useSnackbar();
  const [submitText, setSubmitText] = useState("Add/Update User");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  function trySetEmail(e) {
    setEmail(e);
  }
  const [account, setAccount] = useState("");
  function trySetAccount(e) {
    setAccount(e);
  }
  const [role, setRole] = useState("");
  function assignRole(e) {
    if (e === "admin" || e === "user" || e === "none") {
      setRole(e);
    } else {
      enqueueSnackbar("Role must be 'admin', 'user' or 'none'", {variant: "error"});
      setRole("");
    }
  }
  function trySetRole(e) {
    setRole(e);
  }

  async function tryGetData(e) {
    if (e) {
      setLoading(true);
      const db = getFirestore();
      const docRef = doc(db, "users", e);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setAccount(data.account);
        setRole(data.role);
        setEmail(docSnap.id);
        setSubmitText("Update User");
      }
      setLoading(false);
    } else {
      setAccount("");
      setRole("");
      setEmail("");
      setSubmitText("Add User");
    }
  }

  async function postRequest(e) {
    e.preventDefault();
    setLoading(true);
    try {
      if (account && role && email) {
        const db = getFirestore();
        const docRef = doc(db, "users", email);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.account === account && data.role === role) {
            enqueueSnackbar("No changes to make", {variant: "warning"});
          } else {
            await updateDoc(docRef, {
              account: account,
              role: role,
              updated: serverTimestamp(),
            });
            enqueueSnackbar(
              `Updated ${email} with account:${account}, role:${role}`,
              {variant: "success"},
            );
          }
        } else {
          await setDoc(docRef, {
            account: account,
            role: role,
            created: serverTimestamp(),
            updated: "",
          });
          enqueueSnackbar(
            `Added ${email} with account:${account}, role:${role}`,
            {variant: "success"},
          );
        }
      } else {
        enqueueSnackbar("Please fill out all fields", {variant: "error"});
      }
      setLoading(false);
    } catch (error) {
      enqueueSnackbar(error.message, {variant: "error"});
      setLoading(false);
    }
  }

  const hiddenFileInput = useRef(null);
  function handleClick(event) {
    hiddenFileInput.current.click();
  };
  function handleFileChange(event) {
    setLoading(true);
    const fileUploaded = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, {type: "binary"});
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(sheet);
      console.log(json);
      json.forEach((row) => {
        const email = row["Email"];
        const account = row["Account"];
        const role = row["Role"];
        if (email && account && role) {
          const db = getFirestore();
          const docRef = doc(db, "users", email);
          getDoc(docRef).then((docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              if (data.account === account && data.role === role) {
                enqueueSnackbar(`No changes to make for ${email}`, {variant: "warning"});
              } else {
                updateDoc(docRef, {
                  account: account,
                  role: role,
                  updated: serverTimestamp(),
                  updatedBy: appUser?.id,
                }, {merge: true});
                enqueueSnackbar(
                  `Updated ${email} with account:${account}, role:${role}`,
                  {variant: "success"},
                );
              }
            } else {
              setDoc(docRef, {
                account: account,
                role: role,
                created: serverTimestamp(),
                createdBy: appUser?.id,
                updated: "",
                updatedBy: "",
              });
              enqueueSnackbar(
                `Added ${email} with account:${account}, role:${role}`,
                {variant: "success"},
              );
            }
          });
        } else {
          enqueueSnackbar(`Please fill out all fields for ${email}`, {variant: "error"});
        }
      });
      setLoading(false);
    };
    fileReader.readAsBinaryString(fileUploaded);
  };

  return (
    <>
      {loading ?
        <div className="loading-container">
          <CircularProgress />
        </div>
        :
        <div className="allocate-container">
          <Button className="login-button left-locates" onClick={handleClick} disabled={loading}>Upload users</Button>
          <input
            type="file"
            onChange={handleFileChange}
            ref={hiddenFileInput}
            style={{display: 'none'}}
          />

          <form className='allocate-form'>
            <input
              className='login-text-input'
              name='email-text'
              type='text'
              placeholder='Enter e-mail'
              onChange={(e) => trySetEmail(e.target.value)}
              value={email}
              onBlur={(e) => tryGetData(e.target.value)}
            />
            <input
              className='login-text-input'
              name='account-text'
              type='text'
              placeholder='Enter Account ID'
              onChange={(e) => trySetAccount(e.target.value)}
              value={account}
            />
            <input
              className='login-text-input'
              name='role-text'
              type='text'
              placeholder='Note! Write roles in lowercase: admin, user or none'
              onChange={(e) => trySetRole(e.target.value)}
              value={role}
              onBlur={(e) => assignRole(e.target.value)}
            />
            <Button
              className="login-button left-locates"
              type='submit'
              onClick={postRequest}
              disabled={loading}>
              {loading ? "Requesting..." : submitText}
            </Button>
          </form>
        </div>
      }
    </>
  );
}

export default AdminAddUser;
